import * as MUTATION from '../mutationTypes'
import {
    getWxUserInfo,
    userBindingPhone,
    userLogin
} from '@/models/appInfo'
import {
    setLoginInfo,
    getLoginInfo,
    deleteLoginInfo
} from '../../utils/loginInfo'
import _ from 'lodash'
import {
    getLocalConfig,
    setLocalConfig,
    removeLocalConfig
} from '@/utils/session'
import { isWx } from '@/utils/ua'
import {
    wxConfig
} from '@/utils/wxsdk'
import Vue from 'vue'
import {
    Dialog
} from 'vant'

const state = {
    token: (getLoginInfo() && getLoginInfo().token) || '',
    userName: '',
    phoneMob: '',
    userId: '',
    userLogo: '',
    // loginType: '',
    loading: false,
    isWeixin: false,
    appLoadedClass: '',
    wxUserInfo: getLoginInfo(),
    icarAppInfo: {// 保存养车APP传过来的参数
        java_storeId: '', // java门店Id
        activity_id: '', // 秒杀活动id
        app_name: '', // 养车app标识 'iCar_app'
        sstore_id: '', // php门店id
        user_id: '', // 用户id
        token: '', // 凭证
    }
}

const mutations = {
    [MUTATION.CHECK_WEIXIN] (state, isWX) {
        state.isWeixin = isWX
    },
    [MUTATION.INIT_APP_INFO] (state, config) {
        // 获取缓存中的数据
        let loginInfo = getLoginInfo()
        state.token = loginInfo.token
        // 储存养车app传过来的参数
        Object.assign(state.icarAppInfo, config)
    },
    [MUTATION.SET_APP_CLASS] (state, data) {
        const {
            className
        } = data
        state.appLoadedClass = className
    },
    // login
    [MUTATION.LOGIN_REQUEST] (state) {
        state.loading = true
    },
    [MUTATION.LOGIN_SUCCESS] (state, res) {
        state.loading = false
        state.token = res.token
        state.userName = res.user_name
        state.phoneMob = res.phone_mob
        state.userId = res.user_id
        state.userLogo = res.portrait
    },
    [MUTATION.LOGIN_FAILURE] (state) {
        state.loading = false
        state.token = ''
    },
    [MUTATION.LOGIN_OUT] (state) {
        if (state.isWeixin) {
            state.wxUserInfo = ''
        }
        state.token = ''
    },
    [MUTATION.WX_CODE_ERR] (state) {
        if (state.isWeixin) {
            state.wxUserInfo = ''
        }
        state.token = ''
    },
    [MUTATION.GET_USER_INFO_BY_CODE] (state, data) {
        state.wxUserInfo = data
        state.token = data.token
    }
}

export const actions = {
    // 获取微信授权信息流程，并且进入绑定首页号码的页面
    getWxUserInfo ({
        commit
    }, code) {
        // debugger
        let newCode = getLocalConfig('code')
        // const {
        //     isWeixin
        // } = this.state.appInfo
        return new Promise((resolve, reject) => {
            if (isWx()) {
                if (code) {
                    setLocalConfig('code', code)
                }
                if (getLocalConfig('code') || code) {
                    // 获取用户信息并且缓存到本地
                    getWxUserInfo({
                        code: code || newCode
                    }).then(wxUserInfo => {
                        setLoginInfo(wxUserInfo)
                        commit(MUTATION.GET_USER_INFO_BY_CODE, wxUserInfo)
                        if (wxUserInfo.phone_number) {
                            // 进入下一步流程
                            resolve(wxUserInfo)
                        } else {
                            reject(String('1'))
                            // 进入绑定手机号码页面流程、
                            // Vue.$router.push({
                            //     name: 'bindingPhone'
                            // })
                        }
                    })
                }
            } else {
                resolve()
            }
        })
    },
    // 检查是否是微信客户端
    checkIsWeixin ({
        commit
    }, isWX) {
        commit(MUTATION.CHECK_WEIXIN, isWX)
    },
    // 初始化app的一些数据
    initAppInfo ({
        commit
    }, config) {
        commit(MUTATION.INIT_APP_INFO, config)
    },
    setAppClass ({
        commit
    }, data) {
        commit(MUTATION.SET_APP_CLASS, data)
    },
    async userLogin ({
        commit
    }, params) {
        commit(MUTATION.LOGIN_REQUEST)
        const res = await userLogin(params)
        if (res && !res.errorType) {
            const pikcData = _.pick(res, [
                'token',
                'user_id',
                'portrait',
                'user_name',
                'phone_mob',
                'distribution_user_type'
            ])
            const resConfig = Object.assign({distribution_user_type:1}, pikcData)
            commit(MUTATION.LOGIN_SUCCESS, resConfig)
            setLoginInfo(resConfig)
        } else {
            commit(MUTATION.LOGIN_FAILURE)
        }
    },
    // 用户登录
    async userBindingPhone ({
        commit
    }, params) {
        commit(MUTATION.LOGIN_REQUEST)
        const res = await userBindingPhone(params)
        if (res && !res.errorType) {
            const pikcData = _.pick(res, [
                'token',
                'user_id',
                'portrait',
                'user_name',
                'phone_mob',
                'distribution_user_type'
            ])
            const resConfig = Object.assign({}, pikcData)
            commit(MUTATION.LOGIN_SUCCESS, resConfig)
            setLoginInfo(resConfig)
        } else {
            commit(MUTATION.LOGIN_FAILURE)
        }
    },

    // 登出
    loginOut ({
        commit
    }, data) {
        return new Promise((resolve, reject) => {
            deleteLoginInfo()
            commit(MUTATION.LOGIN_OUT, data)
            resolve()
        })
    },
    // 微信code过期，需要重新获取code
    wxCodeErr ({
        commit
    }, data) {
        return new Promise((resolve, reject) => {
            deleteLoginInfo()
            removeLocalConfig('code')
            commit(MUTATION.WX_CODE_ERR, data)
            resolve()
        })
    },
    // 重新获取code
    getNewCode ({
        commit
    }) {
        return new Promise((resolve, reject) => {
            location.href = wxConfig()
        })
    },
    // 验证手机号码流程
    verifyUserInfo ({
        commit
    }, params = {}) {
        return new Promise((resolve, reject) => {
            const userInfo = getLoginInfo()
            // 有token代表已经登录了
            if ((userInfo && userInfo.token) || state.token) {
                resolve()
            } else {
                const {
                    isWeixin
                } = this.state.appInfo
                // 判断是否微信环境
                if (isWeixin) {
                    // 1. 判断是否有用户信息
                    if (userInfo) {
                        // 判断是否有绑定过手机号码
                        if (userInfo.phone_number) {
                            // 进入购买流程
                            resolve()
                        } else {
                            // 进入绑定手机号码页面流程、
                            Vue.$router.push({
                                name: 'bindingPhone',
                                params
                            })
                        }
                    } else {
                        // 跳转去授权页
                        Dialog
                            .alert({
                                message: '请授权登录',
                                closeOnClickOverlay: true
                            }).then(() => {
                                location.href = wxConfig()
                            }).catch(() => {

                            })
                    }
                    // 2. 如果没有绑定过，则跳去绑定手机号的环
                } else {
                    Vue.$router.push({
                        name: 'login',
                        params
                    })
                    // 判断是否有token
                }
            }
        })
    },
}

export const getters = {
    isApp (state) {
        return state.appInfo.app_name ? 1 : 0
    },
    wxUserInfo (state) {
        return state.appInfo.wxUserInfo
    }
}

export default {
    state,
    mutations
}
